import axios from "axios";
import {useRef, useState} from "react";
import traking from "../../../lib/event/tracker";
import { STRAPI } from "../../../lib/loaders/global";
import styles from "./index.module.css";

const FormMail = ({ room }) => {
  const form = useRef(null);
  const [formMessage, setFormMessage] = useState(null);
  const handleSubmit = async (e) => {
    e.preventDefault();

    let formData = new FormData(form.current);
    var data = {};
    formData.forEach(function (value, key) {
      data[key] = value;
    });

    try {

      const conversation_id = room + Date.now()
      axios.post(`${STRAPI}/api/strapi-chat-plugin/rooms/`, {
        conversation_id,
      })

      await axios.post(`${STRAPI}/api/strapi-chat-plugin/rooms/${conversation_id}/messages`, {
        is_staff: false,
        identity : {
            email : data.email,
            last_name : data.name,
            first_name : data.prenom
        },
        content: `${data.subject}:\n\n${data.message}`,
        staff_author:1,
        is_bot : false
      });
      form.current.reset();
        setFormMessage({
            isErr : false,
            message : "Message envoyé"
        })
    } catch (error) {
      if(error.response){
        if(error.response.status == 400){
          setFormMessage({
            isErr : true,
            message : "Erreur lors de l'envoi du message"
          })
        }
      }
      else console.error(error)
    }
  };
  return (
    <form
      ref={form}
      className={styles.formContain}
      onSubmit={handleSubmit}
      onSubmitCapture={() => {
        traking({
          eventName: "sendMail",
          eventAction: "click",
        });
      }}
    >
      <div className={styles.formLine}>
        <div className={styles.formGroup}>
          <label htmlFor="name">Nom</label>
          <input
            type="text"
            name="name"
            id="name"
            placeholder="Votre Nom"
            required
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="prenom">Prénom</label>
          <input
            type="text"
            name="prenom"
            id="prenom"
            placeholder="Votre Prénom"
            required
          />
        </div>
      </div>
      <div className={styles.formLine}>
        <div className={styles.formGroup}>
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Votre email"
            required
          />
          <small style={{ opacity: 0.5, marginLeft: "2px" }}>
            Utilisé uniquement pour prendre contact avec vous
          </small>
        </div>
      </div>
      <div className={styles.formLine}>
        <div className={styles.formGroup}>
          <label htmlFor="object">Objet</label>
          <input
            type="text"
            id="object"
            name="subject"
            placeholder="Objet du message"
            required
          />
        </div>
      </div>
      <div className={styles.formLine}>
        <div className={styles.formGroup}>
          <label htmlFor="message">Message</label>
          <textarea
            name="message"
            id="message"
            cols="30"
            rows="10"
            placeholder="Votre message"
            required
          ></textarea>
        </div>
      </div>
      {formMessage && (
        <small style={{ color: formMessage.isErr ?'red' : 'green', display:"block" }}>
          {formMessage.message}
        </small>
      )}
      <div className={styles.formLine}>
        <div className={styles.formGroup}>
          <input
            type="submit"
            style={{ background: "#e76417", color: "white" }}
            value="Envoyer"
          />
        </div>
      </div>
    </form>
  );
};

export default FormMail;
